import { initCosmosParallax } from './modules';
import { initFadeOut, animations, forms, code, lazyLoad } from './modules';

const init = () => {
  lazyLoad();
  initCosmosParallax();
  if (document.getElementById('cookie-bar')) {
    document.getElementById('cookie-bar').addEventListener('click', function () {
      document.getElementById('cookie-bar').remove();
    }, false);
  }
};

const onStateChange = () => {
  if (document.readyState === 'complete') {
    initFadeOut();
    animations();
    forms();
    code();
  }
};

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('readystatechange', onStateChange);



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/common.js